import { loadTagAsync } from './load-tag-async';
/**
 * Загружает скрипты и стили
 * @param {BundleResources} bundle
 */
export async function loadBundle(bundle) {
    const headElement = document.head || document.querySelector('head');
    if (typeof bundle.styles !== 'undefined') {
        bundle.styles.forEach(style => {
            let href = style.props.href;
            if (!(href.startsWith('http://') || href.startsWith('https://'))) {
                href = bundle.cdnUrl + href;
                style.props.href = new URL(href).toString();
            }
            const el = headElement.querySelectorAll(`link[src="${style.props.href}"]`);
            if (el.length) {
                return Promise.resolve();
            }
            return loadTagAsync(style);
        });
    }
    if (typeof bundle.scripts !== 'undefined') {
        const scripts = bundle.scripts.map(script => {
            let src = script.props.src;
            if (!(src.startsWith('http://') || src.startsWith('https://'))) {
                src = bundle.cdnUrl + src;
                script.props.src = new URL(src).toString();
            }
            const el = headElement.querySelectorAll(`script[src="${script.props.src}"]`);
            if (el.length) {
                return Promise.resolve();
            }
            return loadTagAsync(script);
        });
        await Promise.all(scripts);
    }
    return bundle;
}
